<template>
  <article class="grid md:grid-cols-1 gap-4">

    <!-- testing Condition Cards on Home Page -->
    <!-- <apply-now-card/>
    <account-blocked-card/>
    <account-expired-card/>
    <incomplete-application-card/>
    <sign-agreement-card/>
    <mandate-register-card/>
    <application-under-review-card/>
    <discrepancies-found-card/> -->

    <template v-if="!applicationRejected">
      <account-blocked-card v-if="creditAccountInfo?.blacklisted" />
      <account-expired-card
        v-else-if="
          creditAccountInfo?.isExpired || creditAccountInfo?.daysToExpire
        "
        :primaryMessage="
          creditAccountInfo?.daysToExpire
            ? `Account Expires in ${creditAccountInfo?.daysToExpire} days`
            : 'Account Expired'
        "
        :secondaryMessage="
          creditAccountInfo?.daysToExpire
            ? 'Please renew to avoid disruption in service'
            : 'Please renew to continue using ePayLater'
        "
      />
      <apply-now-card
        v-else-if="
          !applicationSubStatus || applicationSubStatus === 'initiated' || applicationSubStatus === 'tncAccepted'
        "
      ></apply-now-card>
      <incomplete-application-card v-else-if="applicationCompletionPercentage"></incomplete-application-card>
      <sign-agreement-card
        v-else-if="
          (applicationSubStatus === 'approved' ||
            applicationSubStatus === 'videoVerified' ||
            applicationSubStatus === 'offerSelected' ||
            applicationSubStatus === 'bankDetailsUpdated' ||
            applicationSubStatus === 'nachDownloaded' ||
            applicationSubStatus === 'nachUploaded' ||
            applicationSubStatus === 'emandatePending' ||
            applicationSubStatus === 'emandateSuccess' ||
            applicationSubStatus === 'emandateFailed' ||
            applicationSubStatus === 'documentUploadInProgress' ||
            applicationSubStatus === 'documentUploaded' ||
            applicationSubStatus === 'autoApproved' ||
            applicationSubStatus === 'chequeUploaded') &&
          bestApprovedAmount > 0
        "
      />
      <approved-progress-bar-card v-else-if="creditAccountInfo?.approvedLimit" />
      <mandate-register-card v-else-if="!mandateRegistered" />
      <discrepancies-found-card v-else-if="commentsAvailable" />
      <application-under-review-card
        v-else-if="
          applicationSubStatus === 'readyForOps' ||
          applicationSubStatus === 'nbfcApproved'
        "
      />
    </template>
    <!-- <div class="hidden md:grid grid-cols-3 gap-4 px-4 md:px-0" v-if="showCards">
      <router-link :to="{ name: 'My Cards' }" class="grid" v-if="showCreditCard">
        <dashboard-widget-card-wrapper title="Credit Card" icon="card-image.png" />
      </router-link>
      <router-link :to="{ name: 'Suppliers' }" class="grid">
        <dashboard-widget-card-wrapper
          title="My Suppliers"
          icon="supplier-image.png"
          :subtitle="suppliersCount > 20 ? '20+' : suppliersCount"
        />
      </router-link>
      <router-link :to="{ name: 'Refer And Earn' }" class="grid">
        <dashboard-widget-card-wrapper title="Refer & Earn" icon="refer-image.png" />
      </router-link>
    </div>-->
  </article>
</template>
<script>
import { mapGetters } from 'vuex';
import ApplyNowCard from './ApplyNowCard.vue';
import AccountBlockedCard from './AccountBlockedCard.vue';
import AccountExpiredCard from './AccountExpiredCard.vue';
import IncompleteApplicationCard from './IncompleteApplicationCard.vue';
import SignAgreementCard from './SignAgreementCard.vue';
import ApplicationUnderReviewCard from './ApplicationUnderReviewCard.vue';
import MandateRegisterCard from './MandateRegisterCard.vue';
import DiscrepanciesFoundCard from './DiscrepanciesFoundCard.vue';
import ApprovedProgressBarCard from './ApprovedProgressBarCard.vue';
// import DashboardWidgetCardWrapper from './DashboardWidgetCardWrapper.vue';

export default {
  name: 'DashboardCard',
  components: {
    ApplyNowCard,
    IncompleteApplicationCard,
    SignAgreementCard,
    ApplicationUnderReviewCard,
    DiscrepanciesFoundCard,
    ApprovedProgressBarCard,
    AccountBlockedCard,
    AccountExpiredCard,
    // DashboardWidgetCardWrapper,
    MandateRegisterCard
  },
  computed: {
    ...mapGetters([
      'applicationSubStatus',
      'applicationCompletionPercentage',
      'commentsAvailable',
      'creditAccountInfo',
      'applicationRejected',
      'bestApprovedAmount',
      'showCreditCard',
      'mandateRegistered'
    ]),
  },
  props: {
    suppliersCount: {
      type: Number,
      default: 0,
    },
    showCards: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
